import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from './authSlice';
import { getGuestId } from '../utils/sessionUtils';

const rawBaseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URL,
    credentials: 'include',
    mode: 'cors',
    prepareHeaders: (headers, { getState }) => {
        const userInfo = getState().auth.userInfo;
        if (!userInfo) {
            // For guest, send both X-Guest-Id and x-guest-session (for search history and cart endpoints)
            const guestId = getGuestId();
            headers.set('X-Guest-Id', guestId);
            try {
                // getSessionId is safe to call even if not defined, fallback to guestId
                const { getSessionId } = require('../utils/sessionUtils');
                const sessionId = getSessionId ? getSessionId() : guestId;
                headers.set('x-guest-session', sessionId);
            } catch {
                headers.set('x-guest-session', guestId);
            }
        }

        if (userInfo && userInfo.isAdmin) {
            const activeCompany = getState().admin.activeCompany;
            if (activeCompany && activeCompany.ruc) {
                headers.set('X-Company-RUC', activeCompany.ruc);
            }
        }
        return headers;
    },
});

const baseQuery = async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result?.error?.status === 401) {
        api.dispatch(logout());
    }

    return result;
};

export const apiSlice = createApi({
    baseQuery,
    tagTypes: ['Product', 'Order', 'User', 'Persona', 'Producto', 'Company', 'Cart', 'AdminNotification', 'Discount', 'ActiveGlobalDiscount', 'SalesReport'],
    endpoints: () => ({}),
    refetchOnMountOrArgChange: true, // Ensure we refetch when components mount
});
